module.exports = __webpack_public_path__ + "static/media/5.b90f9f7b.jpg";